export {
  appendQuery
} from './appendQuery.js'

export const initDocumentFontSize = () => {
  let resetFontSize = () => {
    let bodyWidth = document.body.clientWidth
    let fontSize = bodyWidth <= 414 ? 100 * bodyWidth / 750 : 100 * 414 / 750
    document.documentElement.style.fontSize = fontSize + 'px'
  }
  resetFontSize()
  window.addEventListener('load', resetFontSize, false)
  window.addEventListener('orientationchange', resetFontSize, false)
  window.addEventListener('resize', resetFontSize, false)
}

export const hmt = () => { // 百度统计已经加在页面head里面
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?aedb62970cd2e5b7dd727bfed37ac6c5";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

export function parseParams (id, params) {
  const index = id.indexOf(':')
  if (index !== -1) {
    const key = id.substr(index + 1)
    const value = params[key]
    return id.replace(/:.*$/g, value)
  } else {
    return id
  }
}

export function onLoadPreImg (info, key1, key2) {
  info.forEach((item,index) => {
    let temp = new Image()
    temp.src = item[key1]
    temp.onload = function () {
      let element = document.getElementById('cover_' + index)
      if (element) {
        element.src = item[key1]
      }
    }
    temp.onerror = function () {
      if (!key2) return
      let temp2 = new Image()
      temp2.src = item[key2]
      temp2.onload = function () {
        let element = document.getElementById('cover_' + index)
        if (element) {
          element.src = item[key2]
        }
      }
    }
  })
}

export function setDocumentTitle(title) {
  document.title = title
  let i = document.createElement('iframe')
  i.style.display = 'none'
  i.onload = function () {
    setTimeout(() => {
      i.remove()
    }, 0)
  }
  document.body.appendChild(i)
}
